import { ref, computed } from "vue";
import { getJSON } from "@/api/request";
import { getActivityApi } from "@/utils";

// 积分明细相关状态
const page = ref(1);
const scoreLogList = ref<any[]>([]);
const total = ref(0);
const pageSize = 6;

/**
 * 积分明细 Hook
 * 用于管理积分明细的数据获取和分页逻辑
 */
export default function useScoreDetail(showCurErrorTips?: any, isLogin?: any) {
  // 计算总页数
  const totalPages = computed(() => {
    return Math.ceil(total.value / pageSize) || 1;
  });

  // 计算要显示的页码
  const displayPages = computed(() => {
    const pages: (number | string)[] = [];
    const totalPage = totalPages.value;
    const currentPage = page.value;

    if (totalPage <= 7) {
      // 总页数不超过7页，全部显示
      for (let i = 1; i <= totalPage; i++) {
        pages.push(i);
      }
    } else {
      // 总页数超过7页，动态显示页码
      // 始终显示第1页
      pages.push(1);

      // 计算当前页附近要显示的页码范围
      let start = Math.max(2, currentPage - 1);
      let end = Math.min(totalPage - 1, currentPage + 1);

      // 如果当前页靠近开头（1、2、3页），显示前5页
      if (currentPage <= 3) {
        start = 2;
        end = 5;
      }
      // 如果当前页靠近末尾，显示后5页
      else if (currentPage >= totalPage - 2) {
        start = totalPage - 4;
        end = totalPage - 1;
      }

      // 如果起始页码不是2，加省略号
      if (start > 2) {
        pages.push("...");
      }

      // 显示中间页码
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      // 如果结束页码不是倒数第2页，加省略号
      if (end < totalPage - 1) {
        pages.push("...");
      }

      // 始终显示最后一页
      pages.push(totalPage);
    }

    return pages;
  });

  // 获取积分明细列表
  const fetchScoreList = async () => {
    // 检查登录状态
    if (isLogin && !isLogin.value) {
      console.log('未登录，跳过 listMyPoints 请求');
      return { result: 0, code: 10003, msg: 'Not logged in', data: [] };
    }

    const res = await getJSON(
      getActivityApi(window.platform_id, window.activity_name, "listMyPoints"),
      {
        params: JSON.stringify({
          pageNo: page.value,
          pageSize: pageSize,
        }),
      }
    );

    if (res.result === 1) {
      scoreLogList.value = res.data.list || [];
      total.value = res.data.total || 0;
      console.log('积分明细数据:', scoreLogList.value, '总数:', total.value);
    } else {
      console.error('获取积分明细失败:', res);
      showCurErrorTips?.(res.code);
    }

    return res;
  };

  // 切换页码
  const switchPage = (pageNum: number) => {
    page.value = pageNum;
    fetchScoreList();
  };

  // 初始化积分明细列表
  const initScoreList = async () => {
    scoreLogList.value = [];
    page.value = 1;
    await fetchScoreList();
  };

  // 重置积分明细列表
  const resetScoreList = () => {
    scoreLogList.value = [];
    page.value = 1;
    total.value = 0;
  };

  return {
    page,
    scoreLogList,
    totalPages,
    displayPages,
    switchPage,
    initScoreList,
    resetScoreList,
  };
}
